export default {"src":"/_next/static/media/logo-light.b1686f04.svg","height":200,"width":540};